import * as React from 'react';
import { SVGProps } from 'react';

const IconPhoneSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.344 17.978a16.832 16.832 0 0 1-7.322-7.322l2.752-2.052a1 1 0 0 0 .375-1.032L8.015 2.77A1 1 0 0 0 7.042 2h-3.93C2.5 2 2 2.5 2 3.111 2 13.544 10.456 22 20.889 22 21.5 22 22 21.5 22 20.889v-3.932a1 1 0 0 0-.768-.973L16.43 14.84a1 1 0 0 0-1.034.377l-2.052 2.76z" />
  </svg>
);
export default IconPhoneSizeM;
